import { Rocket, Users, Globe, Heart, Lightbulb, TrendingUp } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/hooks/useLanguage";

const iconMap = [Rocket, Users, Lightbulb, Heart, Globe, TrendingUp];

const CareersValues = () => {
  const { t, tObject } = useLanguage();
  const values = tObject<Array<{ title: string; description: string }>>("careersValues.items");

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">{t("careersValues.title")}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">{t("careersValues.description")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {values.map((value, index) => {
            const Icon = iconMap[index] || Rocket;
            return (
              <Card key={index} className="border-border/50 hover:shadow-lg transition-all hover:-translate-y-1">
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-accent" />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">{value.title}</h3>
                  <p className="text-muted-foreground text-sm">{value.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CareersValues;
